import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  dialogContent: {
    textAlign: 'center',
  },
});
